requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('deferred-media')) {
      class DeferredMedia extends HTMLElement {
        constructor() {
          super();
          this.initialize();
        }

        initialize() {
          this.poster = this.querySelectorAll('[id^="Deferred-Poster-"], .rvideo-component__poster');
          if (!this.poster.length) return;

          this.threshold = 200;
          this.loadContentHandler = this.loadContent.bind(this);

          this.poster.forEach(element => element.addEventListener('click', this.loadContentHandler));

          if (this.dataset.preload) {
            this.checkViewportHandler = this.checkViewport.bind(this);

            themeBase.onWindowLoadTrigger(() => {
              ['throttle5fpsMove', 'MutationObserverLoaded', 'updateStickySidebar']
              .forEach(event => window.addEventListener(event, this.checkViewportHandler));
              this.checkViewport();
            });
          }
        }

        loadContent() {
          log('DeferredMedia loadContent', this)
          if (this.getAttribute('loaded')) return;

          const template = this.querySelector('template');
          if (!template) return;
          const content = document.createElement('div');

          content.appendChild(template.content.firstElementChild.cloneNode(true));
          this.media = content.querySelector('video, model-viewer, iframe');
          this.isVideoTag = this.media && this.media.tagName === 'VIDEO';
          if (this.media.autoplay) {
            this.media.preload = 'auto';
            this.media.muted = true;
          }

          const loadeddata = () => {
            if (this.onMediaLoadeddata) this.onMediaLoadeddata();
            let poster = this.querySelector('.rvideo-component__poster');

            if (poster) {
              poster.remove();
              poster = null;
            }

            if (this.media.autoplay) {}
          };

          this.isVideoTag ? this.media.addEventListener('loadeddata', () => loadeddata()) : loadeddata();
          this.setAttribute('loaded', true);
          this.appendChild(this.media);
          if (this.isVideoTag && window.safari && this.media.dataset.src) this.media.src = this.media.dataset.src;
          this.poster.forEach(element => element.removeEventListener('click', this.loadContentHandler));
        }

        checkViewport() {
          if (!themeBase.isInViewport({
              bounds: themeBounds.get(this),
              threshold: this.threshold
            })) {
            return;
          }

          this.loadContent();
          ['throttle5fpsMove', 'MutationObserverLoaded', 'updateStickySidebar']
          .forEach(event => window.removeEventListener(event, this.checkViewportHandler));
        }
      }

      window.DeferredMedia = DeferredMedia;
      customElements.define('deferred-media', DeferredMedia);

      class RvideoComponent extends DeferredMedia {
        constructor() {
          super();
        }

        connectedCallback() {
          let isMediaContentLoaded = false;

          this.onMediaLoadeddata = () => {
            isMediaContentLoaded = true;
          };

          themeBase.onWindowLoadTrigger(() => {
            setTimeout(() => {
              if (isMediaContentLoaded) return;
              this.querySelector('.rvideo-component__poster').classList.remove('hidden');
            }, 1000);
          });

          if (this.querySelector('template')) {
            return;
          }

          this.initHandlers();
        }

        initHandlers() {
          this.video = this.querySelector('video');

          this.addEventListener('click', () => {
            if (this.video.paused) {
              if (!this.video.muted) {
                window.pauseAllMedia();
              }

              this.video.play();
              this.classList.remove('rvideo-component--paused');
            } else {
              this.video.pause();
              this.classList.add('rvideo-component--paused');
            }
          });

          if (!this.video.muted) {
            this.closest('slider-component')?.addEventListener('slideChanged', () => this.video.pause());
          }
        }

        loadContent() {
          super.loadContent();

          if (!this.isVideoTag) {
            this.classList.remove('rvideo-component--paused');
            return;
          }

          this.initHandlers();
        }
      }

      customElements.define('rvideo-component', RvideoComponent);

      scriptController.scripts.push('deferred-media.js');
    }
  });
});